import React from 'react';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { useNavigate } from 'react-router-dom';
import { CSPUrlsMap } from '../../routes/CSPUrlsMap';
import './dashboard.scss';

const LatestClaimsActionButtons = () => {
  const navigate = useNavigate();
  const handleNewClaim = () => {
    navigate(CSPUrlsMap.newClaim.url);
  };
  return (
    <div className="lastClaimsActionButtons">
      <button
        type="button"
        className="button compact outline"
        onClick={() => navigate(CSPUrlsMap.myClaims.url)}
      >
        <span className="labelText">See all claims</span>
      </button>
      <button
        type="button"
        className="button compact primary"
        onClick={handleNewClaim}
      >
        <Icon icon="claim-new" />
        <span className="labelText">Make a new claim</span>
      </button>
    </div>
  );
};

export default LatestClaimsActionButtons;
